import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { PaginatedSustainabilityReportResponse } from './type';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';

export function useSustainabilityReport(year?: number, page = 1) {
  const lang = useLocale();
  return useQuery<PaginatedSustainabilityReportResponse>({
    queryKey: ['sustainability-reports', lang, year, page],
    enabled: true,
    queryFn: async () => {
      const params = new URLSearchParams({ lang, sort: '-published_at', page: page.toString() });

      if (year !== undefined) {
        params.append('year', year.toString());
      }

      const res = await http.get(`/api/sustainability-reports?${params.toString()}`);
      return res.data;
    },
  });
}
